import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useAuth } from "../contexts/AuthContext";
import { apiFetch } from "../api/client";
import { useWorkspace } from "../contexts/WorkspaceContext";

export function JoinWorkspace() {
  const { token } = useParams<{ token: string }>();
  const { token: authToken } = useAuth();
  const navigate = useNavigate();
  const { setWorkspaces, setActiveWorkspace } = useWorkspace();
  const [message, setMessage] = useState("Joining workspace…");
  const joinedRef = useRef(false);

  useEffect(() => {
    if (!authToken) {
      navigate(`/login?redirect=${encodeURIComponent(`/join/${token}`)}`);
      return;
    }
    if (!token) {
      setMessage("Invalid invite link.");
      return;
    }
    if (joinedRef.current) return;
    joinedRef.current = true;

    async function join() {
      const res = await apiFetch(`/workspaces/join/${token}`, { method: "POST" });
      if (res.ok) {
        const ws = await res.json();
        const allRes = await apiFetch("/workspaces");
        if (allRes.ok) {
          const all = await allRes.json();
          setWorkspaces(all);
          setActiveWorkspace(ws);
        }
        navigate("/workspace");
      } else {
        const data = await res.json().catch(() => ({}));
        setMessage((data as { detail?: string }).detail ?? "Invalid or expired invite link.");
      }
    }
    join();
  }, [token, authToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas">
      <div className="text-center space-y-3 px-4">
        <p className="text-ink text-lg">{message}</p>
        {!authToken && (
          <p className="text-ink-2 text-sm">Redirecting to sign in…</p>
        )}
      </div>
    </div>
  );
}
